import {
  GetWidgetResponse,
  Widget,
  WidgetManifest,
  WidgetStatus,
  WidgetTimings,
} from 'src/components/widgets/widgetTypes';

import { ApiMethods, appAPI } from './appApi';

export type { Widget, WidgetManifest, WidgetStatus, WidgetTimings };

export interface CreateWidgetRequest {
  prompt: string;
  model?: string;
}

export interface CreateWidgetResponse {
  widget: Widget;
}

export type { GetWidgetResponse };

export interface ListWidgetsResponse {
  data: Widget[];
}

export const widgetsApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    createWidget: build.mutation<CreateWidgetResponse, CreateWidgetRequest>({
      query: (body) => ({
        path: '/v1/widgets',
        method: ApiMethods.post,
        options: { body },
      }),
    }),
    getWidget: build.query<GetWidgetResponse, string>({
      query: (id) => ({
        path: `/v1/widgets/${id}`,
        method: ApiMethods.get,
        options: {},
      }),
    }),
    listWidgets: build.query<ListWidgetsResponse, void>({
      query: () => ({
        path: '/v1/widgets',
        method: ApiMethods.get,
        options: {},
      }),
    }),
  }),
});

export const {
  useCreateWidgetMutation,
  useGetWidgetQuery,
  useListWidgetsQuery,
} = widgetsApi;
